import { url, header } from "../../apis/Index";
import axios from "axios";
// hhd stands for household head
export const getHhds = () => {
  return (dispatch) => {
    axios
      .get(`${url}/v1/beneficiary-hhds`, {
        headers: header,
      })
      .then((hhds) => {
        dispatch({
          type: "GET_HHDS",
          hhds,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const addnewHhd = (newHHD, actionAfterOperation) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_BEN_HHD_INFO",
      loader: true,
    });
    dispatch({
      type: "CREATING_BEN_HHD_INFO",
      creatingAction: {
        id: null,
        created: false,
      },
    });
    axios
      .post(`${url}/v1/beneficiary-hhds`, newHHD, {
        headers: header,
      })
      .then((hhd) => {
        dispatch({
          type: "CREATING_BEN_HHD_INFO",
          creatingAction: {
            id: hhd.data.id,
            created: true,
          },
        });
        dispatch({
          type: "CREATE_HHD",
          hhd,
        });
        dispatch({
          type: "SENDING_BEN_HHD_INFO",
          loader: false,
        });
        actionAfterOperation(hhd.data.id);
      })
      .catch((error) => {
        dispatch({
          type: "SENDING_BEN_HHD_INFO",
          loader: false,
        });
        dispatch({
          type: "SET_BEN_HHD_MESSAGE",
          message: "Failed to register head of family",
        });
      });
  };
};

export const getHhdById = (id) => {
  return (dispatch) => {
    axios
      .get(`${url}/v1/beneficiary-hhds/${id}`, {
        headers: header,
      })
      .then((hhd) => {
        dispatch({
          type: "GET_HHD",
          hhd,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const updateHhd = (updatedHhd, id, actionAfterOperation) => {
  return (dispatch) => {
    dispatch({
      type: "CREATING_BEN_HHD_INFO",
      creatingAction: {
        id: null,
        created: false,
      },
    });
    dispatch({
      type: "SENDING_BEN_HHD_INFO",
      loader: true,
    });
    axios
      .put(`${url}/v1/beneficiary-hhds/${id}`, updatedHhd, {
        headers: header,
      })
      .then((hhd) => {
        dispatch({
          type: "CREATING_BEN_HHD_INFO",
          creatingAction: {
            id: hhd.data.id,
            created: true,
          },
        });
        dispatch({
          type: "UPDATE_HHD",
          hhd,
        });
        dispatch({
          type: "SENDING_BEN_HHD_INFO",
          loader: false,
        });
        actionAfterOperation();
      })
      .catch((error) => {
        dispatch({
          type: "SENDING_BEN_HHD_INFO",
          loader: false,
        });
        dispatch({
          type: "SET_BEN_HHD_MESSAGE",
          message: "Failed to update record",
        });
      });
  };
};

export const deleteHhd = (id) => {
  return (dispatch) => {
    axios
      .delete(`${url}/v1/beneficiary-hhds/${id}`, {
        headers: header,
      })
      .then(() => {
        dispatch({
          type: "DELETE_HHD",
          id,
        });
      })
      .catch((error) => {});
  };
};
